<script>
	import { nestedTopics, mainTopics, currentTopics } from "../data";
	import { topicColumns } from "../constants";
	import { selectedTopicId, showAllTopicsFilterView } from "../stores";
	import { platform } from "../../../components/MediaQuerySsr.svelte";
	import MoreLess from "../../../components/MoreLess.svelte";
	import { formatFloat } from "../../../utils";
	import Buttons from "../filters/Buttons.svelte";
	import Topic from "../components/Topic.svelte";
	import BackButton from "./BackButton.svelte";
	import { fade, fly } from "svelte/transition";

	const frmt = formatFloat({ digits: 0 });

	let elem;

	let showAllCountries = false;
	let nonCountrySubTopics = [
		"internationale politik --- europapolitik",
		"internationale politik --- außenpolitik",
		"internationale politik --- krieg und frieden",
	];
	let cutCountries = 6;

	$: topicColumnsAdjustedToDevice =
		$platform === "tablet"
			? [
					[...topicColumns[0], ...topicColumns[1]],
					[...topicColumns[2], ...topicColumns[3]],
			  ]
			: topicColumns;

	const exitOnEscape = (e) => {
		if (e.key === "Escape") {
			$showAllTopicsFilterView = false;
		}
	};

	const animate = (node, args) => (args.condition ? fly(node, args) : fade(node, args));
</script>

<svelte:window on:keydown={exitOnEscape} />
<div class="all-topics-view" transition:animate={{ condition: $platform === "mobile", y: -100, duration: 400 }}>
	{#if $platform !== "mobile"}
		<div class="blurry-background" />
	{/if}
	<div class="content">
		{#if $platform !== "mobile"}
			<div class="title-header">
				<div class="title">Themenfilter</div>
				<BackButton />
			</div>
		{/if}
		<div class="section-headline">Aktuelle Kontroversen</div>
		<div class="current">
			<Buttons
				centered={$platform !== "mobile"}
				bind:value={$selectedTopicId}
				options={$currentTopics}
				let:option
				let:active
			>
				<Topic
					colored={active}
					outlined
					shortLabel
					showCount
					topicId={option.id}
					showCloseButton={active}
					onClose={(e) => {
						$selectedTopicId = undefined;
						$showAllTopicsFilterView = false;
						e.stopPropagation();
					}}
				/>
			</Buttons>
		</div>
		<div class="section-headline">Alle Themen</div>
		<div class="all-topics" style="--columns: {topicColumnsAdjustedToDevice.length}">
			{#if Object.keys($nestedTopics).length !== 0}
				{#each topicColumnsAdjustedToDevice as column, i (i)}
					<div class="column">
						{#each column as mainTopicId, j (mainTopicId)}
							{@const mainTopic = $nestedTopics[mainTopicId]}
							{@const subTopics = mainTopic?.subtopics?.sort((a, b) => {
								const aIndex = nonCountrySubTopics.indexOf(a.id);
								const bIndex = nonCountrySubTopics.indexOf(b.id);
								if (aIndex === -1 && bIndex === -1) {
									return b.count - a.count; // sort by count if both are not in nonCountrySubTopics
								}
								if (aIndex === -1) {
									return 1; // move a to the end of the list if it's not in nonCountrySubTopics
								}
								if (bIndex === -1) {
									return -1; // move b to the end of the list if it's not in nonCountrySubTopics
								}
								return b.count - a.count; // sort by count if both are in nonCountrySubTopics
							})}
							{@const shownSubTopics =
								mainTopicId === "internationale politik" && !showAllCountries
									? subTopics.slice(0, cutCountries + 3)
									: subTopics}
							<div class="topic main-topic" style="--topic-color: {mainTopic.color}">
								<div class="background" />
								<div
									class="header"
									on:click={() => {
										$selectedTopicId = mainTopic.id;
										$showAllTopicsFilterView = false;
									}}
								>
									{#if $platform === "mobile"}
										<div class="background" />
									{/if}
									{#if $platform === "mobile"}
										<div class="circle" />
									{/if}
									<div class="text">
										{#if $platform === "mobile"}
											<div class="description">Überthema</div>
										{/if}
										<div class="label">
											{mainTopic.label}
										</div>
									</div>
									<div class="count">{frmt(mainTopic.count || 0)} Demos</div>
								</div>
								{#each shownSubTopics as subTopic, k (subTopic.id)}
									<div
										class="topic sub-topic"
										class:last-sub-topic={k === shownSubTopics.length - 1}
										on:click={() => {
											$selectedTopicId = subTopic.id;
											$showAllTopicsFilterView = false;
										}}
									>
										{#if $platform === "mobile"}
											<img class="arrow" src={`${PATH}assets/images/icons/arrow.svg`} />
										{/if}
										<div class="label">{subTopic.label}</div>
										<!-- {#if k === 0 && ($platform === "mobile" || (j === 0 && i === 0))} -->
										{#if k === 0 && $platform === "mobile"}
											<div class="description">Unterthema</div>
										{/if}
										<div class="count">
											{frmt(subTopic.count || 0)}
										</div>
									</div>
									{#if mainTopic.id === "internationale politik" && k === 2}
										<div class="divider">
											{#if $platform === "mobile"}
												<div>Demos zu bestimmten Ländern</div>
											{/if}
										</div>
									{/if}
									{#if !showAllCountries && mainTopic.id === "internationale politik" && k === cutCountries + 2}
										{@const numberRemaining = subTopics.length - (cutCountries + 3)}
										<div class="moreless-container">
											<MoreLess bind:more={showAllCountries} moreLabel={`+ ${numberRemaining} weitere Länder zeigen`} />
										</div>
									{/if}
								{/each}
								{#if showAllCountries && mainTopic.id === "internationale politik"}
									<div class="moreless-container">
										<MoreLess bind:more={showAllCountries} />
									</div>
								{/if}
							</div>
						{/each}
					</div>
				{/each}
			{/if}
		</div>
	</div>
	{#if $platform === "mobile"}
		<BackButton floating />
	{/if}
</div>

<style lang="scss">
	.blurry-background {
		width: 100vw;
		height: 100vh;
		position: fixed;
		top: 0px;
		left: 0px;
		background-color: rgba($main-blue, 0.7);
		backdrop-filter: blur(9.5px);
		-webkit-backdrop-filter: blur(9.5px);

		// @media (max-width: $breakpoint-mobile-l) {
		// 	background: rgba($main-blue, 0.95);
		// }
	}

	.title-header {
		font-size: 20px;
		font-weight: $bold;
		line-height: 160%; /* 32px */
		letter-spacing: 0.4px;
		margin-left: 15px;
		display: flex;
		justify-content: space-between;
	}

	.all-topics-view {
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
	}

	@media (min-width: #{$breakpoint-mobile-l + 1px}) {
		.content {
			width: 70vw;
			left: 50%;
			padding: 15px 20px 15px 15px;
			background: $main-blue;
			position: absolute;
			top: 20%;
			transform: translate(-50%, 0%);
		}

		.all-topics {
			display: flex;
			--columns: 4;
			--gap: 10px;
			gap: var(--gap);

			.column {
				flex: 1 0 calc((100% / var(--columns)) - var(--gap));

				.count {
					font-size: 12px;
				}

				.main-topic {
					margin-bottom: 10px;

					.header {
						padding-top: 13px;
						padding-bottom: 20px;
						flex-direction: column;
						align-items: flex-start;

						.label {
							font-size: 14px;
							line-height: 125%; /* 17.5px */
						}
					}

					$margin-left: 11px;
					$margin-right: 5px;

					.divider {
						margin-left: $margin-left;
						margin-right: $margin-right;
						margin-top: 8px;
						margin-bottom: 8px;
						border-bottom: 1px dashed #ffffff4c;
						height: unset;
						padding: unset;
					}

					.moreless-container {
						margin-left: $margin-left;
						margin-right: $margin-right;
						padding-top: 4px;
					}

					.sub-topic {
						margin-left: $margin-left;
						margin-right: $margin-right;
						justify-content: space-between;
						border-bottom: none;

						.label {
							font-size: 14px;
							font-weight: $normal;
							margin: 0;
							letter-spacing: 0.28px;
							opacity: 0.8;
							flex-grow: 1;
						}
					}
				}
			}
		}
	}

	.section-headline {
		font-size: 12px;
		font-weight: $medium;
		letter-spacing: 0.96px;
		text-transform: uppercase;
		opacity: 0.5;
		text-align: center;
		margin: 20px 0px 10px 0px;
	}

	.count {
		text-align: right;
		font-size: 13px;
		font-weight: $bold;
		line-height: 40%; /* 5.2px */
		letter-spacing: 0.26px;
		white-space: nowrap;
	}

	.description {
		font-size: 11px;
		font-weight: $medium;
		letter-spacing: 0.88px;
		text-transform: uppercase;
		opacity: 0.4;
	}

	$subtopic-indent: 27px;

	.main-topic .header:hover,
	.sub-topic:hover {
		background: #ffffff20;
	}

	.main-topic {
		position: relative;

		.background {
			background: var(--topic-color);
			opacity: 0.1;
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
		}

		.header {
			border-top: 1px solid var(--topic-color);
			display: flex;
			gap: 10px;
			align-items: center;
			box-sizing: border-box;
			padding: 4px 10px 10px 11px;
			position: relative;
			cursor: pointer;

			.background {
				opacity: 0.12;
			}

			.count {
				color: var(--topic-color);
				flex-grow: 1;
			}

			.label {
				font-size: 18px;
				font-weight: $medium;
				line-height: 120%; /* 21.6px */
			}
		}

		.circle {
			background: var(--topic-color);
			width: 10px;
			height: 10px;
			border-radius: 50%;
			flex-shrink: 0;
		}

		> div.sub-topic,
		> div.divider {
			margin-left: $subtopic-indent;
			margin-right: 10px;
			padding: 4px 0px 6px 0px;
			border-bottom: 1px solid #ffffff20;
		}
	}

	.sub-topic {
		display: flex;
		gap: 6px;
		align-items: baseline;
		cursor: pointer;

		&.last-sub-topic {
			border-bottom: none !important;
		}

		.label {
			opacity: 0.8;
			font-size: 16px;
			font-weight: $medium;
			letter-spacing: 0.32px;
			line-height: 120%;
			margin: 5px 0;
		}

		.count {
			color: #877fa4;
			opacity: 0.7;
		}
	}

	.divider {
		font-size: 12px;
		font-weight: $medium;
		letter-spacing: 0.96px;
		text-transform: uppercase;
		height: 31px;
		display: flex;
		align-items: flex-end;

		> div {
			opacity: 0.5;
		}
	}

	.moreless-container {
		margin-left: $subtopic-indent;
		margin-bottom: 10px;
		padding-bottom: 7px;
	}
</style>
